var map = {
	"./decidim/avatar-multiuser.png": 4705,
	"./decidim/brands/facebook.svg": 69765,
	"./decidim/brands/google.svg": 108,
	"./decidim/brands/twitter-x.svg": 72377,
	"./decidim/cc-badge.png": 91335,
	"./decidim/decidim-logo.svg": 25811,
	"./decidim/default-avatar.svg": 17031,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 44541,
	"./decidim/icons.svg": 17318,
	"./decidim/pattern.png": 75685,
	"./decidim/placeholder-card-g.svg": 45066,
	"./decidim/placeholder-card-l.svg": 7297,
	"./decidim/placeholder.jpg": 30048,
	"./decidim/remixicon.symbol.svg": 59922,
	"./decidim/vendor/social-share-button/douban.svg": 67893,
	"./decidim/vendor/social-share-button/email.svg": 63862,
	"./decidim/vendor/social-share-button/facebook.svg": 50910,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 92658,
	"./decidim/vendor/social-share-button/hacker_news.svg": 22742,
	"./decidim/vendor/social-share-button/linkedin.svg": 94988,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 3493,
	"./decidim/vendor/social-share-button/pinterest.svg": 97968,
	"./decidim/vendor/social-share-button/reddit.svg": 65322,
	"./decidim/vendor/social-share-button/telegram.svg": 90651,
	"./decidim/vendor/social-share-button/tumblr.svg": 27544,
	"./decidim/vendor/social-share-button/twitter.svg": 21979,
	"./decidim/vendor/social-share-button/vkontakte.svg": 15569,
	"./decidim/vendor/social-share-button/wechat.svg": 90628,
	"./decidim/vendor/social-share-button/whatsapp.svg": 11068,
	"./decidim/vendor/social-share-button/x.svg": 35006,
	"./decidim/vendor/social-share-button/xing.svg": 88986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56976;